import * as Constants from './constants';
import { has } from 'lodash';

const initialState = {
  comments: [],
  active: ''
};

const richTextReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.COMMENT_ADD:
      return {
        ...state,
        comments: [...state.comments, action.payload]
      };
    case Constants.ACTIVATE:
      return {
        ...state,
        active: action.payload.id
      };
    case Constants.COMMENT_REMOVE:
      return {
        ...state,
        comments: state.comments.filter(c => c.id !== action.payload.id)
      };
    default:
      return state;
  }
};

const reducer = (state = {}, action) => {
  if (has(Constants, action.type)) {
    return {
      ...state,
      [action.payload.name]: richTextReducer(state[action.payload.name], action),
    };
  }
  return state;
}

export default reducer;
